import { render, staticRenderFns } from "./BuildingDevice.vue?vue&type=template&id=6647d786&scoped=true"
import script from "./BuildingDevice.vue?vue&type=script&lang=js"
export * from "./BuildingDevice.vue?vue&type=script&lang=js"
import style0 from "./BuildingDevice.vue?vue&type=style&index=0&id=6647d786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647d786",
  null
  
)

export default component.exports